export default __webpack_public_path__ + "static/media/coronfel.861d94fe.jpg";